// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
//import Paper from '@material-ui/core/Paper';
//import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import ButtonBase from '@material-ui/core/ButtonBase';
//import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
//import MenuItem from '@material-ui/core/MenuItem';
//import Map from './Map';
//import Map from '../../map/Map';
//import SingleMap from '../../map/SingleMap';
//import SaveIcon from '@material-ui/icons/Save';
//import ImagePicker from './ImagePicker';
//import Option from '../option/View';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signTypeItem : {
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
  },

}));




export default function SignBasic(props) {
	const classes = useStyles();
	const {//handleSend, user, 
        sign, onChange} = props;
	const basicvars = ['ip', 'serialNumber', 'location', 'description',// 'sign_type', 'sign_type_obj'
    ];
	const [basic, setBasic] = React.useState(Object.assign({
		ip: '',
		serialNumber: '',
		location: '', //Name
		description: '',

		//sign_type_obj: {},
		//sign_type: 0,
        
	}, sign));

    //console.log('basic', basic, 'sign', sign);
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value

		if(onChange){
			//console.log('Somethings Changed!');
			onChange({[name] : value});
		} else {
            setBasic((oldval) => Object.assign({}, oldval, {[name] : value}));
        }
	}
    
	React.useEffect(() => {
        //if(sign && sign.id){
        setBasic(basicvars.reduce((bs, v) => ({...bs, [v] : sign[v] !== undefined ? sign[v] : basic[v]}), basic));
        //}
			//var bds = {};
            //basicvars
			//basicvars.forEach((bd) => sign[bd] ?bds[bd] = sign[bd]);
			//setBasic(bds);

	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	return (
		<Card className={classes.root}>
			<CardHeader title={basic.location} />
	  		<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<TextField
							id="sign_location"
							name="location"
							label="Name"
							value={basic.location}
							type="text"
							inputProps = {{
									  maxLength:"25"
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
						<TextField
							id="sign_description"
							name="description"
							label="Description"
							multiline
							maxRows={4}
							value={basic.description}
							onChange={handleChangeValue}
							fullWidth
						/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
						<TextField
							id="sign_ip"
							name="ip"
							label="IP/Modem ID"
							value={basic.ip}
							type="text"
							inputProps = {{
									  maxLength:"25"
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
						<TextField
							id="sign_serial"
							name="serialNumber"
							label="Serial Number"
							value={basic.serialNumber}
							type="text"
							inputProps = {{
									  maxLength:"25"
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
						
						
					</Grid>
					
				</Grid>
	  		</CardContent>
	  	</Card>
	);
}
